<nz-layout class="table-margin">
  @if (title) {
    <nz-header class="table-header">
      @if (
        isEOC() ||
        isInpatientView() ||
        isPreview ||
        data?.length! > 0 ||
        isLoading
      ) {
        <div class="table-header-row margin-lr">
          <div class="table-header-cell">
            {{ title | translate }}
            @if (
              !isLoading &&
              (isEOC() || isInpatientView() || isPreview) &&
              (this.dataGetList?.noKnown ||
                this.dataGetList?.noInfo ||
                (this.dataGetList?.noKnown == false &&
                  this.dataGetList?.noInfo == false &&
                  this.dataGetList?.getAll == null &&
                  this.dataGetList?.getUnknown == null))
            ) {
              <span class="margin-llr">
                <div class="no-known-content">
                  <nz-switch
                    [ngModel]="this.dataGetList?.noKnown"
                    [nzDisabled]="
                      !hasPermission(addPermissions) ||
                      this.dataGetList?.isSubmitted ||
                      isPreview
                    "
                    [nzLoading]="isNoKnownLoading"
                    (ngModelChange)="handleToggle()"
                  ></nz-switch>
                  <div>{{ "No known" | translate }}</div>
                  <div class="add-title">&nbsp;</div>
                  <div class="add-title">{{ title | translate }}</div>
                </div>
              </span>
            }
          </div>
          <div
            class="table-header-cell margin-lrr"
            *hasAddPermissions="addPermissions"
          >
            @if (
              (isEOC() || isInpatientView()) &&
              addComponent &&
              openModalFun &&
              !isPreview
            ) {
              <button nz-button nzShape="round" (click)="openModal()">
                <div fxLayout="row">
                  <div fxLayout="col">
                    <mat-icon class="add-icon">add_circle_outline</mat-icon>
                  </div>
                  <div fxLayout="col" class="add-title">
                    {{ "Add" | translate }} {{ title | translate }}
                  </div>
                </div>
              </button>
            }
          </div>
        </div>
      }
      @if (
        !(isEOC() || isInpatientView()) && !isPreview && !(data?.length! > 0)
      ) {
        <div fxLayout="row" class="table-header-row">
          @if (!isLoading) {
            <div fxLayout="col" class="title">
              {{ title | translate }} - {{ getUnknownText() | translate }}
            </div>
          }
        </div>
      }
    </nz-header>
  }
  @if (
    ((data?.length! > 0 && !this.dataGetList?.noKnown) || isLoading) &&
    !isNoKnownLoading
  ) {
    <nz-content>
      <nz-table
        #nzTable
        nzTableLayout="fixed"
        nzShowTitle="false"
        nzSize="middle"
        nzNoResult="{{ getUnknownText() | translate }}"
        [nzLoading]="isLoading"
        [nzData]="data || []"
        [nzShowPagination]="pagination"
        [nzShowSizeChanger]="pagination"
        nzPaginationType="default"
        [nzFrontPagination]="pagination"
        [nzPageIndex]="currentPageIndex"
        (nzPageIndexChange)="handlePageIndexChange($event)"
        (nzPageSizeChange)="handlePageSizeChange($event)"
        [nzPageSizeOptions]="[5, 10, 20]"
        [nzPageSize]="pageSize"
      >
        <thead>
          <tr>
            @if (expandComponent) {
              <th nzWidth="140px">
                @if (!isPreview) {
                  <button
                    nz-button
                    nzSize="small"
                    nzType="default"
                    (click)="toggleExpandAll()"
                  >
                    <span>{{
                      isAllVisibleExpanded()
                        ? "Collapse All"
                        : ("Expand All" | translate)
                    }}</span>
                  </button>
                }
              </th>
            }
            @for (col of columns; track col) {
              <th>
                <span class="flex items-center gap-2">
                  {{ col | translate }}
                  <app-tooltip [fieldName]="col" [area]="title" />
                </span>
              </th>
            }
            @if (showActions() && !isPreview) {
              <th nzWidth="90px">
                {{ "Actions" | translate }}
                <app-tooltip fieldName="Actions" [area]="title" />
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of filteredData; track item) {
            <tr
              [ngClass]="{
                'draft-entry':
                  item?.['isSubmitted'] !== undefined &&
                  !item?.['isSubmitted'] &&
                  (isEOC() || isInpatientView()),
                'expandable-row': expandComponent,
                'deleted-draft-entry':
                  (item?.['isChecked'] === false &&
                    item?.['isSubmitted'] === false) ||
                  false,
              }"
              (click)="onExpandChange(item.id!)"
            >
              @if (expandComponent) {
                <td [nzExpand]="expandSet.has(item.id!)"></td>
              }
              @for (field of rowFields; track field; let i = $index) {
                <td>
                  @if (field !== "isHospitalized") {
                    <span>
                      @if (getValue(field, item[field]); as value) {
                        <span [ngClass]="checkRV(value, refValues?.at(i))">
                          {{ value }}
                        </span>
                      }
                    </span>
                  } @else {
                    @if (item[field]) {
                      <span>
                        <span
                          nz-icon
                          nz-tooltip
                          nzTooltipTitle="{{ 'Hospitalized' | translate }}"
                          nzTooltipPlacement="topLeft"
                          nzType="icons:bed"
                          nzTheme="outline"
                          class="pr-10"
                        ></span>
                      </span>
                    }
                  }
                </td>
              }
              <!-- DELETE & EDIT -->
              @if (
                (isEOC() || isInpatientView()) &&
                !item["isSubmitted"] &&
                !isItemStopped(item["isStopped"]) &&
                !isPreview
              ) {
                <td>
                  @if (deleteFun) {
                    <i
                      nz-icon
                      nzType="icons:delete"
                      nzTheme="outline"
                      class="delete-btn"
                      (click)="deleteFun(item?.id); $event.stopPropagation()"
                    ></i>
                  }
                  @if (openModalFun) {
                    <i
                      nz-icon
                      nzType="icons:form"
                      nzTheme="outline"
                      class="edit-btn"
                      (click)="openModal(item); $event.stopPropagation()"
                    ></i>
                  }
                </td>
              }
              <!-- STOP -->
              <ng-container *hasStopPermissions="stopPermissions">
                @if (
                  (isEOC() || isInpatientView()) &&
                  item["isSubmitted"] &&
                  !isPreview &&
                  stopFun
                ) {
                  <td>
                    <nz-icon
                      nzType="icons:stop"
                      nzTheme="twotone"
                      [nzTwotoneColor]="'#ff4d4f'"
                      nz-tooltip
                      nzTooltipTitle="{{ 'Stop medication' | translate }}"
                      nzTooltipPlacement="top"
                      class="stop-icon"
                      (click)="stopFun(item?.id); $event.stopPropagation()"
                    ></nz-icon>
                  </td>
                }
              </ng-container>

              <!-- REVERT STOP -->
              <ng-container *hasStopPermissions="stopPermissions">
                @if (
                  (isEOC() || isInpatientView()) &&
                  !item["isSubmitted"] &&
                  isItemStopped(item["isStopped"]) &&
                  !isPreview &&
                  revertStopFun
                ) {
                  <td>
                    <nz-icon
                      nzType="icons:backward"
                      nzTheme="outline"
                      nz-tooltip
                      nzTooltipTitle="{{ 'Resume medication' | translate }}"
                      nzTooltipPlacement="top"
                      class="revert-icon"
                      (click)="
                        revertStopFun(item?.id); $event.stopPropagation()
                      "
                    ></nz-icon>
                  </td>
                }
              </ng-container>
            </tr>
            <tr [nzExpand]="expandComponent && expandSet.has(item.id!)">
              <ng-container
                *ngComponentOutlet="expandComponent; inputs: { item: item }"
              />
            </tr>
          }
        </tbody>
      </nz-table>
    </nz-content>
  }
</nz-layout>

<div *ngComponentOutlet="addComponent"></div>
